import { FC } from "react";

/**
 * Simplified Chinese content for the Sports Betting Rules modal.
 */
const RulesContentCN: FC = () => {
  return (
    <div className="text-sm leading-relaxed text-gray-800 space-y-2">
      <section>
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-2">体育博彩规则</h1>
        </div>

        <div className="flex justify-center items-center pt-4">
          <h2 className="text-xl font-bold">A. 投注类型</h2>
          <hr className="ml-3 flex-1 border-gray-300" />
        </div>

        <div className="pt-4">
          <h3 className="font-bold">1. 1X2</h3>
          <ol>
            <li className="flex pt-2">
              <div>1.1</div>
              <div className="pl-3">
                投注可通过选择主队胜、平局或客队胜来进行。
              </div>
            </li>
            <li className="flex pt-2">
              <div>1.2</div>
              <div className="pl-3">
                投注将在常规比赛时间结束时结算，不包括加时赛和点球（如适用）。
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">2. 亚洲让分盘</h3>
          <ol>
            <li className="flex pt-2">
              <div>2.1</div>
              <div className="pl-3">
                亚洲让分盘是一种投注方式，博彩公司在比赛开始前对两支球队进行让分。以足球为例，博彩公司向其认为更可能获胜的球队设置进球差距，向其认为获胜可能性较低的球队给予先发优势。让分以进球数或进球的分数表示。要赢得投注，最终用户并非单纯押注球队取胜，而是押注该队能否克服让分。
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">3. 正确比分 - 上半场 &amp; 全场</h3>
          <ol>
            <li className="flex pt-2">
              <div>3.1</div>
              <div className="pl-3">上半场正确比分：</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) 投注通过预测所提供投注的比赛或赛事上半场结束时的正确赛果或比分来进行。
              </li>
              <li className="pt-2 pl-3">
                (B) 如果比赛或赛事在上半场结束前被取消、中止或延期，将适用体育通用规则第13条。
              </li>
              <li className="pt-2 pl-3">
                (C) 投注根据比赛或赛事上半场结束时的比分结算，包括因伤停和中断而补足的时间。
              </li>
            </ol>
            <li className="flex pt-2">
              <div>3.2</div>
              <div className="pl-3">全场正确比分：</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) 投注通过预测所提供投注的比赛或赛事结束时的正确赛果或比分来进行。
              </li>
              <li className="pt-2 pl-3">
                (B) 如果比赛或赛事在结束前被取消、中止或延期，将适用体育通用规则第13条。
              </li>
              <li className="pt-2 pl-3">
                (C) 投注根据比赛或赛事的最终比分结算，包括因伤停和中断而补足的时间。
              </li>
            </ol>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">4. 双重机会</h3>
          <ol>
            <li className="flex pt-2">
              <div>4.1</div>
              <div className="pl-3">
                双重机会与 1X2 投注类似，区别在于最终用户能够通过选择以下选项在三种可能结果中投注其中两种：主队胜或客队胜；平局或客队胜；平局或主队胜。
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.2</div>
              <div className="pl-3">
                如果两种可能结果中的其中一种出现，则投注获胜。
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.3</div>
              <div className="pl-3">
                如果比赛在中立场地进行，则为投注目的，网站上列在首位的球队视为主队。
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">5. 首先开球</h3>
          <div className="pt-2">
            预测在比赛/赛事中首先开球的球队或参赛者。
          </div>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">6. 半场/全场</h3>
          <div className="pt-2">
            投注指定比赛的半场和全场赛果（请注意，如果比赛以特定体育投注规则中未明确规定的时间赛制进行，则投注无效）。
          </div>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">7. 混合过关</h3>
          <div className="pt-2">
            混合过关投注是将博彩公司所提供投注的不同场次比赛的多个选项组合在一起的投注。不允许将同一场比赛中的不同选项组合的混合过关投注，因为其中一个选项的结果会影响另一个。
          </div>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">8. 独赢 / 一对一</h3>
          <div className="pt-2">
            独赢 / 一对一投注是对两名配对竞争者之间的比赛或赛事结果进行的投注。如果出现平局结果，所有投注将按 1.00 的赔率退还本金。
          </div>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">9. 下一个进球</h3>
          <ol>
            <li className="flex pt-2">
              <div>9.1</div>
              <div className="pl-3">
                预测在常规比赛时间内于比赛中下一个进球的球队。
              </div>
            </li>
            <li className="flex pt-2">
              <div>9.2</div>
              <div className="pl-3">
                乌龙球计入获得该进球的球队。
              </div>
            </li>
            <li className="flex pt-2">
              <div>9.3</div>
              <div className="pl-3">
                如果比赛被中止，投注将退还本金，除非结果已被无条件确定。
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">10. 单/双</h3>
          <div className="pt-2">
            投注根据投注所涉及的一场或一系列比赛中得分/进球的总和（结果为单数或双数）进行结算。0-0 的比分视为双数。
          </div>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">11. 冠军盘 (Outright)</h3>
          <ol>
            <li className="flex pt-2">
              <div>11.1</div>
              <div className="pl-3">冠军盘投注涉及以下选择：</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) 锦标赛、比赛、联赛、赛跑或赛事（“体育赛事”）（或其任何部分或方面）的冠军；或
              </li>
              <li className="pt-2 pl-3">
                (B) 某支球队或个人竞争者在体育赛事（或其任何部分或方面）中获得由运营商确定的特定名次或名次范围；或
              </li>
              <li className="pt-2 pl-3">
                (C) 两支或多支球队或个人竞争者在体育赛事（或其任何部分或方面）中获得由运营商确定的特定名次范围；可在体育赛事（或其任何部分或方面）开始之前或在其结束之前结果仍未确定的任何阶段进行。
              </li>
            </ol>
            <li className="flex pt-2">
              <div>11.2</div>
              <div className="pl-3">
                以下是运营商接受的冠军盘投注的一些示例：
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) <u>最终赛果</u>
              </li>
              <li className="pt-2 pl-3">
                (B) <u>地区最佳表现者</u>
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) 投注哪支球队或个人竞争者在体育赛事（或其部分或方面）中晋级最远（例如非洲最佳球队、亚洲最佳球队、欧洲最佳球队、北美和中美洲最佳球队以及南美洲最佳球队等）
                  </li>
                  <li className="pt-2 pl-3">
                    (II) 如果来自同一地区的多于一支球队或个人竞争者在同一最远轮次中退出体育赛事，或者如果来自同一地区的所有球队或个人竞争者在小组赛或预选赛中被淘汰，则适用同分规则。
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (C) <u>小组或分区冠军</u>
              </li>
              <li className="pt-2 pl-3">
                (D) <u>最佳射手</u>
              </li>
              <li className="pt-2 pl-3">
                (E) <u>特定名次及小组最佳完赛者</u>
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) 获得冠军以外的特定名次（例如第二名、第三名、半决赛选手等）；或
                  </li>
                  <li className="pt-2 pl-3">
                    (II) 在所选名次范围内（例如前2、5、10名等），而不考虑该球队或个人竞争者在该体育赛事（或其部分或方面）中的确切名次。
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (F) <u>名次预测</u>
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) 顺序预测 - 在所选名次范围内（例如前2、5、10名等），并以体育赛事（或其部分或方面，包括但不限于体育赛事的小组或分区阶段）结束时的正确名次顺序；或
                  </li>
                  <li className="pt-2 pl-3">
                    (II) 双重预测 - 在所选名次范围内（例如前2、5、10名等），而不考虑该球队或个人竞争者在该体育赛事（或其部分或方面，包括但不限于体育赛事的小组或分区阶段）中的确切名次。
                  </li>
                </ol>
              </li>
            </ol>
            <li className="flex pt-2">
              <div>11.3</div>
              <div className="pl-3">
                冠军盘投注可在体育赛事开始之前或在其结束之前该类别投注的结果仍未确定的任何阶段提供。
              </div>
            </li>
            <li className="flex pt-2">
              <div>11.4</div>
              <div className="pl-3">
                冠军盘投注对未上场者不予退款。
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) 未上场者指尽管其名字被列入最终阵容名单但未参加体育赛事的球队、个人竞争者或球员（例如最佳射手）。
              </li>
              <li className="pt-2 pl-3">
                (B) 如果某球队、个人竞争者或球员在体育赛事开始前退出、退役或被取消资格，则对该球队、个人竞争者或球员的投注将退还本金（除非特定体育投注规则另有规定）。
              </li>
              <li className="pt-2 pl-3">
                (C) 如果上述任何情形涉及热门球队、个人竞争者或球员，并进一步影响该体育赛事冠军盘投注的整体赔率或派彩，则该体育赛事的所有冠军盘投注将相应退还本金。
              </li>
            </ol>
            <li className="flex pt-2">
              <div>11.5</div>
              <div className="pl-3">
                同分规则适用于所有冠军盘投注。
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">12. 大/小球</h3>
          <div className="pt-2">
            投注根据投注所涉及的一场或一系列比赛中所取得的得分/进球等总和（结果为大于或小于运营商设定的指定目标数字）进行结算。
          </div>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">13. 阶段投注</h3>
          <ol>
            <li className="flex pt-2">
              <div>13.1</div>
              <div className="pl-3">
                阶段投注是指对比赛的不同部分（例如节、半场、节段、盘、回合或局）进行的投注。
              </div>
            </li>
            <li className="flex pt-2">
              <div>13.2</div>
              <div className="pl-3">
                在阶段投注中，必须完成某一部分，投注才有效。
              </div>
            </li>
            <li className="flex pt-2">
              <div>13.3</div>
              <div className="pl-3">
                在阶段投注中，如无其他说明，确定比分时不包括加时赛或延长时间。
              </div>
            </li>
            <li className="flex pt-2">
              <div>13.4</div>
              <div className="pl-3">
                在符合特定体育投注规则的前提下，下半场的阶段投注在确定比分时应包括加时赛。
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">14. 组合过关</h3>
          <div className="pt-2">
            组合过关是混合过关的一项功能，可便利您从所选赛事中进行多种组合的投注。要使用组合过关功能，您需要从混合过关市场页面中选择 3 至 8 场所提供投注的不同赛事或比赛。不允许从同一赛事或比赛中选择其中一个结果会影响另一个的多个选项。您所选择的赛事数量将影响您可使用的组合过关功能类型。例如，当您选择了 4 场赛事时：
          </div>
          <ol type="1" className="pt-2">
            <li>
              1. <b>Event A</b> (Manchester City vs West Ham United)
            </li>
            <li>
              2. <b>Event B</b> (Cittadella vs Hellas Verona)
            </li>
            <li>
              3. <b>Event C</b> (Cordoba vs Osasuna)
            </li>
            <li>
              4. <b>Event D</b> (Liverpool vs Tottenham Hotspur)
            </li>
          </ol>
          <div className="py-3">从以上赛事中，您可以选择使用：</div>
          <div className="pl-4">
            <ul className="pb-3 list-disc">
              <li>
                <b>Double</b>（6 注 - <b>AB</b>、<b>AC</b>、{" "}
                <b>AD</b>、<b>BC</b>、<b>BD</b> 和 <b>CD</b> 共 6 种组合）
              </li>
              <li>
                <b>Treble</b>（4 注 - <b>ABC</b>、<b>ABD</b>、{" "}
                <b>ACD</b> 和 <b>BCD</b> 共 4 种组合）
              </li>
              <li>
                <b>4-Folds</b>（1 注 - <b>ABCD</b> 共 1 种组合）
              </li>
              <li>
                <b>Double</b>、<b>Treble</b> 和 <b>4-Folds</b>（共 11 注）
              </li>
            </ul>
          </div>
          <div className="pb-3 overflow-x-auto">
            <table className="border-collapse [&_th]:border [&_td]:border [&_th]:px-2 [&_td]:px-2 [&_th]:py-1 [&_td]:py-1 [&_td]:text-center">
              <thead>
                <tr>
                  <th>所选赛事数量</th>
                  <th>DOUBLE</th>
                  <th>TREBLE</th>
                  <th>4-FOLDS</th>
                  <th>5-FOLDS</th>
                  <th>6-FOLDS</th>
                  <th>7-FOLDS</th>
                  <th>8-FOLDS</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>3</td>
                  <td>3 注</td>
                  <td>1 注</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>6 注</td>
                  <td>4 注</td>
                  <td>1 注</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>10 注</td>
                  <td>10 注</td>
                  <td>5 注</td>
                  <td>1 注</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>15 注</td>
                  <td>20 注</td>
                  <td>15 注</td>
                  <td>6 注</td>
                  <td>1 注</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>21 注</td>
                  <td>35 注</td>
                  <td>35 注</td>
                  <td>21 注</td>
                  <td>7 注</td>
                  <td>1 注</td>
                  <td></td>
                </tr>
                <tr>
                  <td>8</td>
                  <td>28 注</td>
                  <td>56 注</td>
                  <td>70 注</td>
                  <td>56 注</td>
                  <td>28 注</td>
                  <td>8 注</td>
                  <td>1 注</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">15. 亚洲 1X2</h3>
          <div className="pt-2">
            在亚洲 1X2 中，您可以投注任一球队或平局结果。当您下注时，确认投注单之前已有的任何进球将被抵消。
            <br />
            如果您投注欧洲 1X2，则您只是投注赛事的最终结果。
            <br />
            以日本和英格兰之间的比赛为例，英格兰目前以 0:1 领先日本。（参照上述赛事，1 = 日本，X = 平局，2 = 英格兰。）
          </div>
          <div className="py-3">
            如果您在亚洲 1X2 中投注日本队的情形。
          </div>
          <div className="overflow-x-auto">
            <table className="border-collapse [&_th]:border [&_td]:border [&_th]:px-2 [&_td]:px-2 [&_th]:py-1 [&_td]:py-1 [&_td]:text-center">
              <thead>
                <tr>
                  <th>全场比分 (Japan vs. England)</th>
                  <th>下注时的比分</th>
                  <th>全场比分 (Japan vs. England)</th>
                  <th>投注结果</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1 : 1</td>
                  <td>0 : 1</td>
                  <td>1 : 0</td>
                  <td>赢</td>
                </tr>
                <tr>
                  <td>0 : 2</td>
                  <td>0 : 1</td>
                  <td>0 : 1</td>
                  <td>输</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="py-3">
            如果您在亚洲 1X2 中投注<b>平局</b>的情形。
          </div>
          <div className="overflow-x-auto">
            <table className="border-collapse [&_th]:border [&_td]:border [&_th]:px-2 [&_td]:px-2 [&_th]:py-1 [&_td]:py-1 [&_td]:text-center">
              <thead>
                <tr>
                  <th>全场比分 (Japan vs. England)</th>
                  <th>下注时的比分</th>
                  <th>全场比分 (Japan vs. England)</th>
                  <th>投注结果</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>0 : 1</td>
                  <td>0 : 1</td>
                  <td>0 : 0</td>
                  <td>赢</td>
                </tr>
                <tr>
                  <td>0 : 2</td>
                  <td>0 : 1</td>
                  <td>0 : 1</td>
                  <td>输</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section>
        <div className="flex justify-center items-center pt-4">
          <h2 className="text-xl font-bold">B. 体育通用规则</h2>
          <hr className="ml-3 flex-1 border-gray-300" />
        </div>
        <div className="pt-2">
          除特定体育投注规则另有规定外，将适用以下体育通用规则：
        </div>

        <div className="pt-4">
          <h4 className="font-bold">1. 规则的适用性</h4>
          <div className="pt-2">
            运营商接受的所有投注均受本规则约束。
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">
            2. 英文与其他语言之间的不一致
          </h4>
          <div className="pt-2">
            如果网站上使用的英文名称与非英文名称之间存在任何不一致，应以英文版本为准。
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">3. 规则的解释</h4>
          <div className="pt-2">
            如果对本规则的解释存在任何争议，应以运营商对本规则的解释为准。
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">4. 投注方式</h4>
          <div className="pt-2">
            我们仅接受通过网站、WAP 或事先通过电话安排进行的投注。
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">5. 赛事详情</h4>
          <div className="pt-2">
            网站上显示的赛事详情（日期、中立场地、开赛、计时、红牌、球员和球队的统计信息或新闻）（包括在直播中心显示的详情）仅供一般参考。最终用户有责任在下注前确保并核实此类详情正确无误。运营商对网站上显示或访问的任何赛事详情或视频流中的任何错误、误差、时滞或遗漏概不负责。
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">6. 最高投注额</h4>
          <div className="pt-2">
            每笔投注的最高金额根据具体投注类型而有所不同，运营商有权不经事先通知予以变更。
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">7. 场地变更</h4>
          <ol className="pt-2">
            <li className="flex">
              <div>7.1</div>
              <div className="pl-3">
                如果场地发生变更（主队改为客场作战或反之），则该场比赛的所有投注将无效。
              </div>
            </li>
            <li className="flex pt-2">
              <div>7.2</div>
              <div className="pl-3">
                如果比赛原定在中立场地进行，但在非中立场地进行（或反之），则所有投注仍然有效。
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">8. 提前开赛/开始</h4>
          <div className="pt-2">
            在原定比赛开始之前下的所有投注均有效。在原定比赛开始之后下的投注将无效，除非这些投注是作为 In Running ("Live") 投注服务的一部分进行的。
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">9. 赔率波动</h4>
          <ol className="pt-2">
            <li className="flex">
              <div>9.1</div>
              <div className="pl-3">
                运营商的所有赔率随时可能波动。只有当最终用户所选择的赔率被提交给运营商并被运营商接受时，投注才有效。
              </div>
            </li>
            <li className="flex pt-2">
              <div>9.2</div>
              <div className="pl-3">
                如果最终用户所选择的赔率在投注提交与运营商接受之间变为对最终用户有利的更好赔率，则最终用户的投注将按更好的赔率被接受。
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">10. 赔率类型</h4>
          <div className="pt-2">
            运营商提供以下赔率类型供投注：
          </div>
          <ol type="A" className="pt-2">
            <li className="pt-2 pl-3">(A) 欧洲赔率</li>
            <li className="pt-2 pl-3">(B) 马来赔率</li>
            <li className="pt-2 pl-3">(C) 印尼赔率</li>
            <li className="pt-2 pl-3">(D) 香港赔率</li>
            <li className="pt-2 pl-3">(E) 缅甸赔率</li>
          </ol>
          <div className="pt-2 pb-2">
            有关各种赔率类型的更多信息，请联系我们的客户服务部门或参阅我们网站上的教程。
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">11. 72 小时规则</h4>
          <div className="pt-2">
            所有公布的赛果将在 72 小时后成为最终结果，此后不再受理任何查询。
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">12. 取消的赛事</h4>
          <div className="pt-2">
            如果赛事在开始前因任何原因被取消，则对该赛事所下的所有投注将无效，并按 1.00 的赔率退还。
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">
            13. 延期、中止或未完成的赛事（12 小时规则）
          </h4>
          <div className="pt-2">
            如果赛事被中止或延期，且未在原定开始时间起 12 小时内恢复（除非特定体育规则另有规定），则所下的所有投注将退还本金。例外情形为在实际比赛中断之前已被无条件确定的投注。在此类情形下，此类投注将有效。
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">14. 市场暂停</h4>
          <div className="pt-2">
            运营商保留随时暂停某一市场或不接受投注的权利。当某一市场被暂停时，对该市场所下但在被运营商接受之前的任何投注将被拒绝。运营商还保留随时不经通知停止任何市场投注的权利。
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">15. 因失误或错误而使投注无效</h4>
          <div className="pt-2">
            如果对任何赛事报出了错误的参赛者（或参赛球队的错误成员）或错误的赔率/价格，或运营商依据错误信息编制其赔率或投注，或在 In Running ("Live") 投注期间录入了错误的比分或详情，或投注因错误而被接受，则运营商保留使该赛事或该参赛者的此类或全部投注无效的权利。
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">16. 因投注无效而退还本金</h4>
          <div className="pt-2">
            所有被宣布无效的投注将退还原始本金。
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">17. 异常投注</h4>
          <div className="pt-2">
            运营商保留不经事先通知而拒绝、驳回或暂停任何被怀疑作弊、黑客攻击、攻击、操纵或破坏运营商正常投注运营（包括网站）的最终用户的权利。任何“异常投注”将不经事先通知而无效。严禁在网站上使用人工智能或“机器人”。运营商将采取措施防止和检测用于使人工智能（非人类）利用网站的程序。最终用户任何企图或实际使用人工智能来作弊、黑客攻击、攻击、操纵或破坏运营商投注运营的行为，将导致其账户被终止和/或投注无效，由运营商酌情决定。
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">18. 未完成的混合过关投注</h4>
          <div className="pt-2">
            如果混合过关投注中的某一赛事或比赛因任何原因被取消、未进行或未完成，则被取消/未参与的投注部分将无效，但混合过关投注的其余部分将仍然有效并重新计算赔率。
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">19. 投注的裁定</h4>
          <ol className="pt-2">
            <li className="flex">
              <div>19.1</div>
              <div className="pl-3">
                赛事的获胜者将根据赛事结束时的相关结果确定。赛事获胜者的裁定与结算以及所有投注的裁定与结算，根据投注类型及与相关投注类型有关的条款和条件，应在赛事结束并在所有相关结果经核对和核实之后进行。运营商应在赛事结束后于合理范围内尽快尽最大努力核对和核实所有相关结果。一旦相关结果经核对、核实并公布，任何随后的抗议、上诉或被推翻的裁决将不被认可为投注目的。
              </div>
            </li>
            <li className="flex pt-2">
              <div>19.2</div>
              <div className="pl-3">
                尽管特定体育投注规则、体育博彩规则和本体育通用规则中有任何规定，运营商仍可自行酌情根据投注类型及与该（些）投注类型有关的条款和条件，在任何比赛/赛事结束之前的任何时间并不时对任何一笔或多笔投注进行裁定和/或结算，前提是此类投注在运营商进行此类裁定时可被无条件确定。
              </div>
            </li>
            <li className="flex pt-2">
              <div>19.3</div>
              <div className="pl-3">
                上述第 19.1 条和/或第 19.2 条中的任何内容均不影响运营商将任何已裁定和/或已结算的投注视为裁定和/或结算错误的权利。此类错误的裁定和/或结算应无效，并由运营商予以撤销，运营商应据此根据运营商适用的条款和条件重新裁定和/或重新结算这些受影响的投注。
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">20. 同分规则</h4>
          <div className="pt-2">
            如果有两名或多名获胜者，派彩赔率（扣除本金）将按获胜者数量进行分配并相应结算，本金予以退还。
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">21. 虚拟对阵比赛</h4>
          <ol className="pt-2">
            <li className="flex">
              <div>21.1</div>
              <div className="pl-3">
                虚拟对阵比赛投注涉及任意两支球队的虚拟配对。虚拟对阵比赛的结果由两支配对球队在各自比赛中所取得的进球/得分数决定。获胜球队为进球/得分数最高的球队，包括让分（如有）。
              </div>
            </li>
            <li className="flex pt-2">
              <div>21.2</div>
              <div className="pl-3">
                在虚拟对阵比赛中配对的球队必须在同一天开始各自的比赛，尽管一场比赛可能比另一场结束得晚，但两场比赛都必须在一个连续的时段内进行（即不得有延期、改期或中止的比赛），投注才有效。
              </div>
            </li>
            <li className="flex pt-2">
              <div>21.3</div>
              <div className="pl-3">
                在符合上述规则 19.2 的前提下，如果任何配对球队的比赛被延期、改期或中止，则涉及这些球队的所有虚拟对阵比赛投注将无效。
              </div>
            </li>
            <li className="flex pt-2">
              <div>21.4</div>
              <div className="pl-3">
                这些虚拟对阵比赛不考虑比赛的场地（主场或客场）。
              </div>
            </li>
            <li className="flex pt-2">
              <div>21.5</div>
              <div className="pl-3">
                除上述规定外，虚拟对阵比赛规则将遵循提供虚拟对阵比赛投注的特定体育项目的规则。
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">
            22. 与官方结果不一致的赛果/比分
          </h4>
          <ol className="pt-2">
            <li className="flex">
              <div>22.1</div>
              <div className="pl-3">
                如果官方比赛结果与运营商网站上的结果之间存在冲突，运营商保留在核实赛果/比分之前暂停此类投注的裁定和/或结算最多 72 小时或其他必要期间的权利。
              </div>
            </li>
            <li className="flex pt-2">
              <div>22.2</div>
              <div className="pl-3">
                该冲突应参照比赛/赛事的视频录像予以解决，根据此类视频录像所作出的对正确比分/赛果的任何裁定应优先于官方比赛结果。
              </div>
            </li>
            <li className="flex pt-2">
              <div>22.3</div>
              <div className="pl-3">
                如无可用的视频录像，正确的比分/赛果应参照该体育项目管理机构官方网站上公布的比分/赛果予以确定，除非官方网站公布的结果明显错误，在此情况下运营商应尽最大努力确定用于裁定获胜者和/或赛果的正确结果。在此类情形下，运营商的决定为最终决定。
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">23. IN RUNNING ("LIVE") 投注服务</h4>
          <ol className="pt-2">
            <li className="flex">
              <div>23.1</div>
              <div className="pl-3">
                In Running ("Live") 投注仅适用于运营商指定为滚球投注市场的那些体育项目，并且仅针对那些在赛事列表中标记为“live”或“live bets”或带有 LIVE 标志的比赛，或网站上名为“LIVE”的专门文件中的比赛。
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.2</div>
              <div className="pl-3">
                In Running ("Live") 投注是指允许最终用户在比赛或赛事进行期间下注，直至运营商停止该比赛或赛事的投注为止。
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.3</div>
              <div className="pl-3">
                在亚洲让分盘的 In Running ("Live") 投注中，网站上显示两种计分系统：
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) 更新并显示当前比分或结果的情形（"Type A Scoring"）。投注的结算由比赛或阶段投注结束时（取决于投注的性质）的最终比分结果（包括让分）减去下注及接受投注时的当前比分确定。
              </li>
              <li className="pt-2 pl-3">
                (B) 不显示当前比分或结果，而显示 0-0 比分或结果的情形（"Type B Scoring"）。投注的结算由比赛或阶段投注结束时（取决于投注的性质）的最终比分结果（包括让分）确定。建议最终用户在下注前核实比赛状态。
              </li>
            </ol>
            <li className="flex pt-2">
              <div>23.4</div>
              <div className="pl-3">
                根据具体体育项目，特定市场可由运营商全权酌情提供投注。如果无法下注或实时比分更新不正确，运营商不承认也不接受任何责任。以比赛结束时显示的比分或结果为有效。
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.5</div>
              <div className="pl-3">
                在任何时候，最终用户均有责任了解比分，并建议在下注前核实比赛状态。
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.6</div>
              <div className="pl-3">
                除特定体育投注规则另有规定外，在 In Running ("Live") 比赛过程中网站上显示的任何信息、统计或编辑文本（例如比分、计时器或结果）纯粹仅供一般参考，不应作为投注依据。
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.7</div>
              <div className="pl-3">
                与非滚球投注一样，赛事的获胜者将根据赛事结束时的相关结果确定。抗议、上诉或被推翻的裁决将不被认可为投注目的，结果的后续变更不会影响投注的结果。
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.8</div>
              <div className="pl-3">
                运营商保留随时不经通知暂停某一市场或不接受投注的权利。当某一市场被暂停时，对该市场所下但在被运营商接受之前的任何投注可由运营商酌情予以拒绝。在滚球市场暂停或停止之前接受的任何投注仍然有效，而在滚球投注停止之后所下的任何投注将不被接受，除非特定体育投注规则另有规定。
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.9</div>
              <div className="pl-3">
                在 In Running ("Live") 投注情形下：
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) 所下投注将处于待定状态：
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) 当运营商认为可能发生高风险/危险时刻时；或
                  </li>
                  <li className="pt-2 pl-3">
                    (II) 在比赛中高风险/危险时刻之前及期间。
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (B) 上述规则 B23.9(a) 中所述的投注将在每张投注单上标示为“待定（Pending）”，直至运营商全权酌情接受或拒绝该投注为止。
              </li>
              <li className="pt-2 pl-3">
                (C) 高风险/危险时刻定义如下：
                <ol type="I">
                  <li className="pt-2 pl-3">(I) 角球；</li>
                  <li className="pt-2 pl-3">(II) 点球；</li>
                  <li className="pt-2 pl-3">
                    (III) 进攻方在靠近对方禁区区域获得任意球；
                  </li>
                  <li className="pt-2 pl-3">
                    (IV) 进攻方在靠近对方禁区区域获得界外球；
                  </li>
                  <li className="pt-2 pl-3">
                    (V) 当一支球队处于活跃进攻模式的潜在得分情形时；或
                  </li>
                  <li className="pt-2 pl-3">
                    (VI) 由运营商全权酌情决定。
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (D) 所有快速市场投注将不受上述规则 B23.9 (a) 至 (c) 的约束，此类投注将被接受而不处于待定状态。
              </li>
            </ol>
            <li className="flex pt-2">
              <div>23.10</div>
              <div className="pl-3">
                所有处于待定状态的亚洲让分盘和大/小球投注（不包括总黄牌数、总角球数、总越位数、总换人数的投注和/或对比赛整体结果没有影响的投注），如果发生以下情形之一，将被取消：
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">(A) 进球；或</li>
              <li className="pt-2 pl-3">(B) 球员被罚下场。</li>
            </ol>
            <li className="flex pt-2">
              <div>23.11</div>
              <div className="pl-3">
                所有其他投注，例如总黄牌数、总角球数、总越位数、总换人数的投注和/或对比赛整体结果没有影响的投注，可由运营商酌情接受。
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.12</div>
              <div className="pl-3">
                运营商应全权酌情确定任何进球或得分的时间。官方联赛/俱乐部网站、媒体网站或“实时比分”网站所述的进球或得分时间可供参考之用，但对运营商确定时间不具约束力。
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.13</div>
              <div className="pl-3">
                如果运营商有理由相信或怀疑滚球投注是在滚球赛事结果已知之后下的，或者如果延迟的“实时”电视转播导致在所选参赛者已获得优势之后以不正确的价格下了滚球投注（由运营商全权酌情确定），则运营商有权将该投注视为无效，而无需提供任何理由。
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.14</div>
              <div className="pl-3">
                如果发生任何技术故障，包括网站崩溃或任何阻碍、延迟或妨碍运营商访问网站以更新比分、赔率或让分的停机，运营商保留取消事件发生时所下的所有待定投注的权利。
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.15</div>
              <div className="pl-3">
                关于滚球投注，适用有关结果评估的通用规则。如果滚球赛事在比赛过程中被中断，导致赛事被延期或中止，则对此类延期或中止赛事所下且未在赛事开始时间起 12 小时内重新开始的任何投注（除非特定体育投注规则另有专门规定）应无效。例外情形为在实际比赛中断之前已被无条件确定的投注。在此类情形下，此类投注将有效。
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.16</div>
              <div className="pl-3">
                In Running ("Live") 混合过关。Live 混合过关投注是由 Live 与非 Live 投注的选项组合而成的混合过关投注，其中至少 1 场比赛必须为 Live 赛事。Live 混合过关投注还必须由至少 3 场不同比赛的选项组合而成。所有选项都必须被接受，Live 混合过关投注才有效。任何选项被拒绝都将导致 Live 混合过关投注也被拒绝。
              </div>
            </li>
          </ol>
        </div>
      </section>

      <section>
        <div className="flex justify-center items-center pt-4">
          <h2 className="text-xl font-bold">C. 特定体育投注规则</h2>
          <hr className="ml-3 flex-1 border-gray-300" />
        </div>
        <div className="pt-2">
          以下规则是适用于对各项体育项目所下投注的特殊投注规则，与体育通用规则一起规范最终用户对运营商所有互动体育博彩产品的使用。
        </div>

        <div className="pt-4">
          <h3 className="font-bold">1. 篮球</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>1.1</div>
              <div className="pl-3">
                投注要有效，当比赛剩余部分被取消时，原定比赛时间必须剩余 5 分钟或更少，但在比赛被取消之前已被无条件确定的投注除外（例如阶段投注）。
              </div>
            </li>
            <li className="flex pt-2">
              <div>1.2</div>
              <div className="pl-3">
                除非另有规定，结算将根据包括加时赛（如适用）在内的官方最终比分进行。
              </div>
            </li>
            <li className="flex pt-2">
              <div>1.3</div>
              <div className="pl-3">
                对于 NCAAB，网站上标示的“主场”和“客场”场地仅供参考。
              </div>
            </li>
            <li className="flex pt-2">
              <div>1.4</div>
              <div className="pl-3">以下是篮球所提供的投注：</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) 非滚球投注
                <ol type="I">
                  <li className="pt-2 pl-3">(I) 亚洲让分盘</li>
                  <li className="pt-2 pl-3">
                    (II) 首先得分
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 投注将根据比赛中首先得分的球队进行结算。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) 如果比赛在首先得分后被中止，所有投注仍然有效。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (III) 每节得分最高的球队
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 投注比赛中每一节得分最高的球队，不包括加时赛。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (IV) 最后得分
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 投注将根据比赛中最后得分的球队进行结算（包括加时赛中所得的任何分数）。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) 如果比赛被中止，所有最后得分的投注将无效。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(V) 单/双</li>
                  <li className="pt-2 pl-3">(VI) 冠军盘 (Outright)</li>
                  <li className="pt-2 pl-3">(VII) 大/小球</li>
                  <li className="pt-2 pl-3">
                    (VIII) 阶段投注
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 半场投注
                        <ol type="1">
                          <li className="pt-2 pl-3">
                            (1) 对于上半场投注，投注根据第 1 节和第 2 节比分之和（包括让分）来确定获胜者进行结算。
                          </li>
                          <li className="pt-2 pl-3">
                            (2) 对于下半场投注，投注根据第 3 节和第 4 节比分之和（包括让分）来确定获胜者进行结算。下半场投注包括加时赛中所取得的比分（如适用）。
                          </li>
                        </ol>
                      </li>
                      <li className="pt-2 pl-3">
                        (B) 单节投注
                        <ol type="1">
                          <li className="pt-2 pl-3">
                            (1) 投注根据每节结束时所取得的比分（包括让分）来确定获胜者进行结算。
                          </li>
                          <li className="pt-2 pl-3">
                            (2) 对于第 4 节投注，确定获胜者时不包括加时赛中所得的进球或分数。
                          </li>
                        </ol>
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (IX) 率先得20分
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 投注比赛中率先得到 20 分的球队。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (X) 球队/球员的总得分/篮板/助攻/抢断/盖帽/三分球：
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 结算根据该场比赛中球员或球队的统计数据进行。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) 对未上场者（即未参加比赛任何部分的球员）的投注将退还本金。
                      </li>
                      <li className="pt-2 pl-3">
                        (C) 对上场但未得分、未获篮板或未助攻的球员的投注将视为得零分。
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (B) In Running ("Live") 投注
                <ol type="I">
                  <li className="pt-2 pl-3">(I) 亚洲让分盘</li>
                  <li className="pt-2 pl-3">(II) 大/小球</li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (C) 计分系统
                <div className="pt-1">
                  适用 Type B Scoring。移动端网站上显示的实时记分牌仅供参考。投注的结算应由 Type B Scoring 系统确定。
                </div>
              </li>
            </ol>
            <li className="flex pt-2">
              <div>1.5</div>
              <div className="pl-3">电子篮球投注</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) 除本规则 8.5 另有规定外，规则 8 应适用于电子篮球投注。
              </li>
              <li className="pt-2 pl-3">
                (B) 电子篮球比赛是基于人工智能、机器学习和历史篮球数据库的模拟，以反映球队状态和比赛过程。
              </li>
              <li className="pt-2 pl-3">
                (C) 除非另有规定，每场比赛分为四节，每节 12 分钟，总比赛时间为 48 分钟。
              </li>
              <li className="pt-2 pl-3">
                (D) 电子篮球比赛结果、比分和其他决定投注的数据应为软件所产生的数据，无法从任何其他来源（包括官方球队或联赛网站）获得。
              </li>
              <li className="pt-2 pl-3">
                (E) 电子篮球比赛为转播比赛，因此被视为共同投注比赛，即多于一名最终用户能够对特定比赛下注，且该比赛的结果将决定所有最终用户所下投注的结果。
              </li>
              <li className="pt-2 pl-3">
                (F) 如果任何比赛因任何类型的技术故障（包括但不限于计算机、电子、软件、硬件或连接故障）未在原定时间内完成，则该比赛应由运营商结算为未完成。在此类情形下，仅结算已被无条件确定的投注。对于所有其他市场，无论任何指示性结果如何，投注应无效，本金退还给最终用户。运营商应根据本规则结算此类比赛，运营商的决定为最终决定。
              </li>
              <li className="pt-2 pl-3">
                (G) 运营商保留在以下情况下宣布电子篮球投注无效的权利：
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) 仅有部分或不正确的投注详情可用；
                  </li>
                  <li className="pt-2 pl-3">
                    (II) 运营商怀疑一名或多名最终用户参与欺诈、串通、洗钱或其他非法活动；
                  </li>
                  <li className="pt-2 pl-3">
                    (III) 比赛未开始或未完成，或结果无法确定；
                  </li>
                  <li className="pt-2 pl-3">
                    (IV) 接受该投注将超出任何投注限额；
                  </li>
                  <li className="pt-2 pl-3">
                    (V) 最终用户账户中没有该本金金额；
                  </li>
                  <li className="pt-2 pl-3">
                    (VI) 错误（人为或其他）或系统故障导致使用了不正确的赔率；
                  </li>
                  <li className="pt-2 pl-3">
                    (VII) 发生技术故障，例如通信故障、缺陷、中断、延迟、病毒、拒绝服务攻击或数据损坏；或
                  </li>
                  <li className="pt-2 pl-3">
                    (VIII) 如果技术缺陷产生了过高或异常的奖金。
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (H) 如果由于错误（人为或其他）或系统故障导致投注结算不正确，则该结算将被视为无效并予以撤销。如果最终用户账户中没有足够的资金来允许此项操作，则最终用户将被要求向运营商返还必要的金额。
              </li>
            </ol>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">2. 拳击</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>2.1</div>
              <div className="pl-3">
                为投注目的，拳手在比赛中被取消资格将计为其对手的击倒获胜。
              </div>
            </li>
            <li className="flex pt-2">
              <div>2.2</div>
              <div className="pl-3">
                如果拳手未能在某一回合开始时应铃出场，或在回合之间被取消资格，则其对手将被视为在上一回合获胜。
              </div>
            </li>
            <li className="flex pt-2">
              <div>2.3</div>
              <div className="pl-3">以下是拳击所提供的投注：</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) 非滚球投注
                <ol type="I">
                  <li className="pt-2 pl-3">(I) 亚洲让分盘</li>
                  <li className="pt-2 pl-3">
                    (II) 单/双
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 单/双投注与比赛中宣布获胜者的回合数有关（无论是单数还是双数）。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (III) 大/小球
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 大/小球投注与比赛中宣布获胜者的回合数有关（结果为大于或小于运营商为该场比赛设定的指定目标回合数）。
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
            </ol>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">3. 棒球</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>3.1</div>
              <div className="pl-3">
                所有棒球投注均以两名所列投手出战该场比赛为基础提供。两名投手都必须出战比赛并至少投出一球，投注才有效。如果任一投手因任何原因未能出战比赛，则对该赛事所下的所有投注将无效，并按 1.00 的赔率退还。
              </div>
            </li>
            <li className="flex pt-2">
              <div>3.2</div>
              <div className="pl-3">
                如果我们未在某支球队旁注明投手，则对该球队接受的投注无论先发投手如何均仍然有效。
              </div>
            </li>
            <li className="flex pt-2">
              <div>3.3</div>
              <div className="pl-3">
                比赛的结果将根据比赛结束时的官方结果（包括加时局，如适用）确定。
              </div>
            </li>
            <li className="flex pt-2">
              <div>3.4</div>
              <div className="pl-3">
                国际棒球规则：如果在对方球队至少击球 7 局后一支球队领先另一支球队 10 分或以上，或者在对方球队至少击球 5 局后一支球队领先 15 分或以上，则比赛将提前结束。在此类赛事中，所有投注均视为有效。
              </div>
            </li>
            <li className="flex pt-2">
              <div>3.5</div>
              <div className="pl-3">
                日本棒球规则：如果比赛在 12 局后被宣布为平局，则所有投注均视为有效。日本棒球规则仅适用于日本棒球联赛。
              </div>
            </li>
            <li className="flex pt-2">
              <div>3.6</div>
              <div className="pl-3">以下是棒球所提供的投注：</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) 非滚球投注
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) 亚洲让分盘
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 对于全场亚洲让分盘投注，如果比赛进行少于 9 局，所有投注将无效，但当主队在 8½ 局后领先且比赛提前结束的情况除外。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (II) 独赢投注
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 如果比赛进行少于 5 局，所有投注将无效，但当主队在 4½ 局后领先且比赛提前结束的情况除外。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(III) 冠军盘 (Outright)</li>
                  <li className="pt-2 pl-3">
                    (IV) 大/小球
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 对于全场大/小球投注，如果比赛进行少于 9 局，所有投注将无效，但当主队在 8½ 局后领先且比赛提前结束的情况除外。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (V) 阶段投注
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 前五局投注（F5 投注）
                      </li>
                      <li className="pt-2 pl-3">
                        (B) 所有投注均根据前五局结束时的比分进行结算。如果比赛未进行满五个完整局，所有前五局投注将被取消。全场亚洲让分盘和全场大/小球投注的规则不适用于前五局投注。
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (B) In Running ("Live") 投注
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) 亚洲让分盘
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 如果比赛进行少于 9 局，所有投注将无效，但当主队在 8½ 局后领先且比赛提前结束的情况除外。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (II) 大/小球
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 如果比赛进行少于 9 局，所有投注将无效，但当主队在 8½ 局后领先且比赛提前结束的情况除外。
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (C) 计分系统
                <div className="pt-1">适用 Type A Scoring</div>
              </li>
            </ol>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">4. 板球</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>4.1</div>
              <div className="pl-3">
                所有比赛投注将根据官方比赛规则进行结算。如果比赛受恶劣天气影响，投注将根据官方比赛结果进行结算。如果没有官方比赛结果，所有投注将无效。
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.2</div>
              <div className="pl-3">
                板球同分规则是指当至少有两名竞争者/球队被宣布为获胜者时（同分），在明确的获胜者结算之后剩余的派彩名次数量将除以共享这些名次的竞争者/球队数量。然后将该选项的赔率乘以所得的数值。
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.3</div>
              <div className="pl-3">
                在平局的情况下，如果官方体育赛事规则未确定获胜者，则将适用板球同分规则。
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.4</div>
              <div className="pl-3">
                除非另有规定，在由 bowl off 或 super over 决定获胜者的体育赛事中，投注将根据官方比赛结果进行结算。
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.5</div>
              <div className="pl-3">
                如果比赛因外部因素被中止，则投注将无效，除非根据官方体育赛事规则宣布了获胜者。
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.6</div>
              <div className="pl-3">
                如果比赛被取消，则若未在其公布的开始时间起 36 小时内重赛或重新开始，所有投注将无效。
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.7</div>
              <div className="pl-3">
                对于一级比赛，如果投出的局数少于 200 个 over，投注将无效，除非由于投注的结果已被确定而可对任何投注进行结算。
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.8</div>
              <div className="pl-3">
                在限制 over 数的比赛中，如果因外部因素（包括但不限于恶劣天气）导致任一局未能完成至少 80% 的原定 over 数，投注将无效，除非由于投注的结果在减少之前已被确定而可对任何投注进行结算。
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.9</div>
              <div className="pl-3">
                以下是板球非滚球和 In Running ("Live") 投注所提供的投注：
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) 比赛、球队和球员投注
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) 1X2
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 对于一级比赛，如果官方结果为平局，投注将根据两队之间的板球同分规则进行结算。对平局的投注将按输处理。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(II) Over 内的边界球</li>
                  <li className="pt-2 pl-3">
                    (III) 掷币获胜者
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 如果未进行掷币，所有投注将无效。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(IV) 出局方式</li>
                  <li className="pt-2 pl-3">(V) 每 Over / 每局出局数</li>
                  <li className="pt-2 pl-3">(VI) 双重机会</li>
                  <li className="pt-2 pl-3">
                    (VII) 平局退款 (Draw No Bet)
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 对于一级比赛，平局将根据板球同分规则进行结算。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(VIII) 最高个人得分</li>
                  <li className="pt-2 pl-3">
                    (IX) 最高开局合作得分
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 所有投注将根据开局合作得分的 runs 进行结算。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (X) 全场最佳球员
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 投注将根据官方宣布的全场最佳球员进行结算。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) 如果未官方宣布全场最佳球员，则所有投注将无效。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XI) 比赛鸭蛋数 / 总鸭蛋数
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 鸭蛋是指击球手以零 runs 出局。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) 为结算目的，因伤退场的击球手不计为出局。
                      </li>
                      <li className="pt-2 pl-3">
                        (C) super over 中的鸭蛋不计算在内。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XII) 比赛额外得分 / 总额外得分
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 比赛中所有 wide 投球、no ball、bye、leg bye 和罚分均计入最终结果。如果同一次投球既有击球得分又有额外得分，则击球得分不计入最终总数。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) super over 中的额外得分不计算在内。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XIII) 比赛四分球 / 总四分球
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 只有从击球（任何投球——合法与否）所得的四分球才计入总四分球。overthrow、所有跑动得四分和额外得分均不计算在内。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) super over 中所得的四分球不计算在内。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XIV) 比赛 run out 数 / 总 run out 数
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) super over 中的 run out 不计算在内。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XV) 比赛六分球 / 总六分球
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 只有从击球（任何投球——合法与否）所得的六分球才计入总六分球。overthrow 和额外得分均不计算在内。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) super over 中所得的六分球不计算在内。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XVI) 比赛 wide 数 / 总 wide 数
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 由 wide 投球所产生的任何 runs（罚分除外）均计入最终总数。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) super over 中的 wide 不计算在内。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XVII) 比赛 wicket 数 / 总 wicket 数
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 接受对比赛中将倒下的 wicket 总数的投注。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) 为结算目的，因伤退场的击球手不计为一个 wicket。
                      </li>
                      <li className="pt-2 pl-3">
                        (C) super over 中的 wicket 不计算在内。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XVIII) 比赛中最高 Over
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 预测比赛中得分最高的 over 所得的 runs。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) 所有 runs（包括额外得分）均计入结算。
                      </li>
                      <li className="pt-2 pl-3">
                        (C) super over 不计算在内。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XIX) 最多接杀
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 投注将接杀最多的球队，包括守场员和守门员的接杀。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) 对于一级比赛，只有第一局的接杀才计算在内。
                      </li>
                      <li className="pt-2 pl-3">
                        (C) super over 中所得的接杀不计算在内。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XX) 最多额外得分
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 比赛中所有 wide 投球、no ball、bye、leg bye 和罚分均计入最终结果。如果同一次投球既有击球得分又有额外得分，则击球得分不计入最终总数。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) super over 中的额外得分不计算在内。
                      </li>
                      <li className="pt-2 pl-3">
                        (C) 对于一级比赛，只有第一局的额外得分才计算在内。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXI) 最多四分球
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 只有从击球（任何投球——合法与否）所得的四分球才计入总四分球。overthrow、所有跑动得四分和额外得分均不计算在内。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) super over 中所得的四分球不计算在内。
                      </li>
                      <li className="pt-2 pl-3">
                        (C) 对于一级比赛，只有第一局的四分球才计算在内。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXII) 最多守门员接杀
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 如果球队在某局中途更换守门员，则替补守门员所得的接杀将计入结算。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) super over 中所得的接杀不计算在内。
                      </li>
                      <li className="pt-2 pl-3">
                        (C) 对于一级比赛，只有第一局的接杀才计算在内。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXIII) 最多六分球
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 只有从击球（任何投球——合法与否）所得的六分球才计入总六分球。overthrow 和额外得分均不计算在内。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) super over 中所得的六分球不计算在内。
                      </li>
                      <li className="pt-2 pl-3">
                        (C) 对于一级比赛，只有第一局的六分球才计算在内。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXIV) 最多 stumping
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 对于一级比赛，只有第一局的 stumping 才计算在内。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) super over 中所得的 stumping 不计算在内。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(XXV) 冠军盘 (Outright)</li>
                  <li className="pt-2 pl-3">(XXVI) 大/小球</li>
                  <li className="pt-2 pl-3">
                    (XXVII) 球员一对一
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 如果球员未击球或投球，但在首发十一人名单中，所有投注仍然有效。如果球员不在首发十一人名单中，投注将无效。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) 如果投注时所设的盘口被越过，则结果将被视为已确定。
                      </li>
                      <li className="pt-2 pl-3">
                        (C) 对于一级比赛，只有第一局才计算在内。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXVIII) 球员表现
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 这些市场使用基于积分的计分系统来确定其结果。这是一个综合得分，每 run 计 1 分，每个 wicket 计 20 分，每次接杀计 10 分，每次 stumping 计 25 分。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXIX) Rabbit Runs
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 投注比赛中第 11 号击球手所得的总 runs。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) 第 11 号击球手被视为该局中最后上场击球的球员，无论先前所述的顺序如何。如果有超过 11 名球员击球，则对该市场的所有投注将无效。
                      </li>
                      <li className="pt-2 pl-3">
                        (C) 如果该局在第 11 号击球手未上场击球的情况下完成，则该击球手将被视为得零分（0）。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXX) 第一个 Over 的 runs
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 第一个 over 必须完成，投注才有效，除非由于投注的结果已被确定而可对任何投注进行结算。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) 如果某局在一个 over 进行过程中结束，则该 over 将被视为已完成，除非该局因外部因素（包括但不限于恶劣天气）结束，在此情况下所有投注将无效，除非由于投注的结果已被确定而可对任何投注进行结算。
                      </li>
                      <li className="pt-2 pl-3">
                        (C) 对于一级比赛，该市场仅指每队的第一局。
                      </li>
                      <li className="pt-2 pl-3">
                        (D) 该特定 over 中的额外得分和罚分将计入结算。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXI) 开局合作得分的 runs
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 如果击球队在第一个 wicket 倒下之前达到其分配的 over 数或达到其目标 runs 或宣布结束，则结果将为所累积的总 runs。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) 如果投注时所设的盘口被越过，或某个 wicket 已倒下，则结果将被视为已确定。
                      </li>
                      <li className="pt-2 pl-3">
                        (C) 为结算目的，因伤退场的击球手不计为一个 wicket。
                      </li>
                      <li className="pt-2 pl-3">
                        (D) 对于一级比赛，该市场仅指每队的第一局。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXII) 各组 Over 内的 runs
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 如果指定的 over 数未完成，投注将无效，除非球队全部出局或宣布结束或达到其 run 目标，或由于投注的结果在减少之前已被确定而可对任何投注进行结算。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) 对于一级比赛，该市场仅指第一局。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXIII) 第一次投球所得的 runs
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 为结算目的，所有非法球均计为投球。如果该 over 以 wide 开始，则第一次投球将结算为 1，并且尽管尚未投出合法球，下一球将被视为该 over 的第 2 次投球。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) 如果该次投球导致 free hit，则额外投球所得的 runs 不计算在内。所有 runs，无论是否来自击球，均包括在内。例如，一个 wide 加上额外跑动 3 runs 等于该次投球共计 4 runs。
                      </li>
                      <li className="pt-2 pl-3">
                        (C) 对于一级比赛，该市场仅指每队的第一局。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXIV) 以边界球结束的球队
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXV) 每次出局时得分最高的球队
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXVI) 得分最高 Over 的球队
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXVII) 平局比赛
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 对于一级比赛，平局是指在第四局击球的一方在比分持平时全部出局。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXVIII) 最佳击球手 / 拥有最佳击球手的球队
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 预测比赛中个人得分最高的击球手。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) 在限制 over 数的比赛中，如果因外部因素（包括但不限于恶劣天气）导致在下注时未能完成每局原定投出的 over 数的至少 50%，投注将无效。
                      </li>
                      <li className="pt-2 pl-3">
                        (C) 一级比赛的最佳击球手投注仅适用于每队的第一局，如果投出的 over 数少于 200，投注将无效，除非两队的第一局均已完成。
                      </li>
                      <li className="pt-2 pl-3">
                        (D) 如果某击球手在掷币时被列入名单，但后来作为替补被替换下场，则该击球手仍将被计算在内，替补击球手也将被计算在内。
                      </li>
                      <li className="pt-2 pl-3">
                        (E) 当两名或多名击球手得到相同数量的 runs 时，将适用板球同分规则。
                      </li>
                      <li className="pt-2 pl-3">
                        (F) super over 中所得的 runs 不计算在内。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXIX) 最佳投球手 / 拥有最佳投球手的球队
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 预测比赛中获得最多 wicket 的投球手。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) 在限制 over 数的比赛中，如果因外部因素（包括但不限于恶劣天气）导致在下注时未能完成每局原定投出的 over 数的至少 50%，投注将无效。
                      </li>
                      <li className="pt-2 pl-3">
                        (C) 一级比赛的最佳投球手投注仅适用于每队的第一局，如果投出的 over 数少于 200，投注将无效，除非两队的第一局均已完成。
                      </li>
                      <li className="pt-2 pl-3">
                        (D) 如果某投球手在掷币时被列入名单，但后来作为替补被替换下场，则该投球手仍将被计算在内，替补投球手也将被计算在内。
                      </li>
                      <li className="pt-2 pl-3">
                        (E) 如果两名或多名投球手获得相同数量的 wicket，则失分最少的投球手将为获胜者。如果获得相同数量的 wicket 且失分相同，则将适用板球同分规则。
                      </li>
                      <li className="pt-2 pl-3">
                        (F) super over 中所得的 wicket 不计算在内。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(XL) 每次出局时的总得分</li>
                  <li className="pt-2 pl-3">(XLI) 总出局数</li>
                  <li className="pt-2 pl-3">
                    (XLII) 得分最高 Over 中的总得分
                  </li>
                  <li className="pt-2 pl-3">
                    (XLIII) 每 Over / 每局的总 runs
                  </li>
                  <li className="pt-2 pl-3">
                    (XLIV) 各组 Over 内的 wicket
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 投注指在指定的 over 数内将倒下的 wicket。
                      </li>
                      <li className="pt-2 pl-3">
                        (B) 如果指定的 over 数未完成，投注将无效，除非球队全部出局或宣布结束或达到其 run 目标，或由于投注的结果已被确定而可对任何投注进行结算。
                      </li>
                      <li className="pt-2 pl-3">
                        (C) 为结算目的，如果某击球手超时出局或主动退场出局，则该 wicket 被视为发生在上一球。为结算目的，因伤退场的击球手不计为出局。
                      </li>
                      <li className="pt-2 pl-3">
                        (D) 对于一级比赛，该市场仅指每队的第一局。
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
            </ol>
            <li className="flex pt-2">
              <div>4.10</div>
              <div className="pl-3">
                适用于板球投注的计分系统为 Type B Scoring。
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">5. 足球</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>5.1</div>
              <div className="pl-3">
                除本足球投注规则另有规定外，所有投注均根据常规比赛时间（包括裁判增加的任何伤停补时）进行结算，不包括加时赛和点球大战。
              </div>
            </li>
            <li className="flex pt-2">
              <div>5.2</div>
              <div className="pl-3">
                如果比赛安排为非常规时间进行（例如各类锦标赛或友谊赛的特殊比赛时段），所有投注将根据该原定时间结束时的最终比分进行结算。
              </div>
            </li>
            <li className="flex pt-2">
              <div>5.3</div>
              <div className="pl-3">
                除非在所有足球比赛之前在网站上明确标示非常规时间比赛，否则对此类比赛接受的投注将视为无效。
              </div>
            </li>
            <li className="flex pt-2">
              <div>5.4</div>
              <div className="pl-3">
                如果官方网站上公布的比赛状态或结果明显错误，或比赛未在常规时间内完成，运营商应尽最大努力确定比赛的正确状态和结果。在比赛未在原定常规时间内完成的任何情况下［常规时间定义为可进行比赛的原定总时间，包括官员指示的伤停补时］，比赛应由运营商结算为未完成。在此类情形下，仅结算已被无条件确定的市场。对于所有其他市场，投注应无效，本金退还给玩家。运营商应根据本规则结算此类比赛，运营商的决定为最终决定。
              </div>
            </li>
            <li className="flex pt-2">
              <div>5.5</div>
              <div className="pl-3">
                以下是足球所提供的投注。In Running ("Live") 投注将在“Live”版块中单独提供。
              </div>
            </li>
            <ol type="I">
              <li className="pt-2 pl-3">(I) 1X2</li>
              <li className="pt-2 pl-3">(II) 亚洲让分盘</li>
              <li className="pt-2 pl-3">
                (III) 零封 (Clean Sheet)
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) 预测球队是否会在指定比赛中保持零封并不失任何球。（例如，A 队以 3-0 击败 B 队，A 队“保持了零封”，因为他们没有失任何球）
                  </li>
                  <li className="pt-2 pl-3">
                    (B) 如果比赛被中止，所有投注将退还本金。
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (IV) 正确比分 - 上半场 &amp; 全场
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) 要赢得正确比分，您所选择的球队（主队或客队）必须以正确的赛果或比分获胜。
                  </li>
                  <li className="pt-2 pl-3">
                    (B) 要赢得正确比分 UP-5，您所选择的球队（主队或客队）必须以 5 个或以上的净胜球差获胜。
                  </li>
                  <li className="pt-2 pl-3">
                    (C) 要赢得 AOS 或“任何其他比分”，您所选择的球队（主队或客队）必须以市场上未列出的赛果或比分获胜。
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (V) 双重机会
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) 从 3 个可用选项中投注 3 种可能结果中的 2 种（例如主队胜或平局 (1X)、客队胜或平局 (X2)、主队胜或客队胜 (12)）。
                  </li>
                  <li className="pt-2 pl-3">
                    (B) 如果比赛在中立场地进行，投注将根据我们网站上显示的比赛场地（主队/客队）进行结算。
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">(VI) 虚拟对阵比赛</li>
              <li className="pt-2 pl-3">
                (VII) 第一个角球
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) 预测在常规比赛时间内于指定比赛中获得第一个角球的球队。
                  </li>
                  <li className="pt-2 pl-3">
                    (B) 如果比赛在第一个角球判罚后被中止，所有第一个角球的投注仍然有效。
                  </li>
                  <li className="pt-2 pl-3">
                    (C) 如果比赛在第一个角球判罚前被中止，所有第一个角球的投注将退还本金。
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (VIII) 第一个进球 / 最后一个进球 / 无进球
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) 预测在常规比赛时间内于指定比赛中开球后的第一个、最后一个或无进球。
                  </li>
                  <li className="pt-2 pl-3">
                    (B) 乌龙球计入获得该进球的一方。（例如，A 队对 B 队，B 队打入乌龙球使比分变为 1-0，则第一个进球将判给 A 队）。
                  </li>
                  <li className="pt-2 pl-3">
                    (C) 如果比赛在进球后被中止，所有第一个进球和无进球的投注仍然有效，但所有最后一个进球的投注将退还本金。
                  </li>
                  <li className="pt-2 pl-3">
                    (D) 如果比赛在无任何进球的情况下被中止，所有第一个、最后一个和无进球的投注将退还本金。
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (IX) 第一次 / 最后一次越位
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) 预测在常规比赛时间内于指定比赛中第一次/最后一次越位的球队。
                  </li>
                  <li className="pt-2 pl-3">
                    (B) 如果比赛在第一次越位后被中止，所有第一次越位的投注仍然有效，但所有最后一次越位的投注将退还本金。
                  </li>
                  <li className="pt-2 pl-3">
                    (C) 如果比赛在任何越位发生前被中止，所有第一次/最后一次越位的投注将退还本金。
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (X) 第一次/最后一次换人
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) 预测在常规比赛时间内于指定比赛中两支球队中哪一支将进行第一次/最后一次球员换人。
                  </li>
                  <li className="pt-2 pl-3">
                    (B) 如果同时换下两名以上球员，则第四官员首先出示的球员号码将被视为结果。
                  </li>
                  <li className="pt-2 pl-3">
                    (C) 如果比赛在第一次换人完成后被中止，所有第一次换人的投注仍然有效，但所有最后一次换人的投注将退还本金。
                  </li>
                  <li className="pt-2 pl-3">
                    (D) 如果比赛在任何换人完成前被中止，所有第一次/最后一次换人的投注将退还本金。
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XI) 第一张黄牌
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) 预测在常规比赛时间内于指定比赛中获得第一张黄牌的球队。
                  </li>
                  <li className="pt-2 pl-3">
                    (B) 如果该判罚为直接红牌（职业犯规），则将视为红牌而非黄牌。
                  </li>
                  <li className="pt-2 pl-3">
                    (C) 如果两名或多名球员因同一事件被判罚，则裁判首先出示第一张黄牌的球员将被视为结果。
                  </li>
                  <li className="pt-2 pl-3">
                    (D) 向非球员（例如替补/后备球员、领队或教练）出示的黄牌不计算在内。
                  </li>
                  <li className="pt-2 pl-3">
                    (E) 如果比赛在第一张黄牌出示后被中止，所有第一张黄牌的投注仍然有效。
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XII) 进球球员
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) 预测指定比赛中的进球球员。
                  </li>
                  <li className="pt-2 pl-3">
                    (B) 如果所选球员未在比赛中出场，投注将退还本金。
                  </li>
                  <li className="pt-2 pl-3">
                    (C) 如果所选球员在常规比赛时间内的任何时候上场，投注仍然有效。
                  </li>
                  <li className="pt-2 pl-3">
                    (D) 乌龙球和点球大战中所进的球不计算在内。
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XIII) 最后一个角球
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) 预测在常规比赛时间内于指定比赛中获得最后一个角球的球队。
                  </li>
                  <li className="pt-2 pl-3">
                    (B) 如果比赛在常规比赛时间内被中止，所有最后一个角球的投注将退还本金。
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">(XIV) 单/双</li>
              <li className="pt-2 pl-3">
                (XV) 冠军盘 (Outright)
                <ol type="A">
                  <li className="pt-2 pl-3">(A) 最佳射手</li>
                </ol>
              </li>
              <li className="pt-2 pl-3">(XVI) 大/小球</li>
              <li className="pt-2 pl-3">
                (XVII) 点球大战
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) 让分/让球
                    <ol type="1">
                      <li className="pt-2 pl-3">
                        (1) 点球让分结果包括突然死亡。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (B) 大/小球
                    <ol type="1">
                      <li className="pt-2 pl-3">
                        (1) 点球大/小球结果不包括突然死亡，并以每队 5 次点球为基础。
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XVIII) 点球判罚
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) 预测在常规比赛时间内于指定比赛中被判罚并主罚的点球。
                  </li>
                  <li className="pt-2 pl-3">
                    (B) 如果比赛在点球被判罚并主罚后被中止，所有投注仍然有效。
                  </li>
                  <li className="pt-2 pl-3">
                    (C) 如果比赛在点球被判罚并主罚前被中止，所有投注将退还本金。
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XIX) 阶段投注
                <div className="pt-1">10 分钟和 15 分钟赛事</div>
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) 10 分钟和 15 分钟赛事投注由比赛中每 10 分钟或 15 分钟时段内的动作总数（例如：进球、角球或判罚）决定。（例如：00:00-15:00；15:01-30:00）
                  </li>
                  <li className="pt-2 pl-3">
                    (B) 动作的时间应根据官方比赛时间确定。
                  </li>
                  <li className="pt-2 pl-3">
                    (C) 超出特定投注时段的待定投注将被拒绝并退还本金。
                  </li>
                  <li className="pt-2 pl-3">
                    (D) 重新执行的动作不计入计数。
                  </li>
                  <li className="pt-2 pl-3">
                    (E) 适用总判罚数（特定体育投注规则 xxi）规则。
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XX) 总进球数
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) 总进球数投注涉及预测投注所涉及的比赛中累计的总进球数或总得分。
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XXI) 总判罚数
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) 只有从击球（任何投球——合法与否）所得的四分球才计入总四分球。overthrow、所有跑动得四分和额外得分均不计算在内。
                  </li>
                  <li className="pt-2 pl-3">
                    (B) super over 中所得的四分球不计算在内。
                  </li>
                  <li className="pt-2 pl-3">
                    (C) 对于一级比赛，只有第一局的四分球才计算在内。
                    <ol type="i">
                      <li className="pt-2 pl-3">(i) 1 张黄牌 = 1 分</li>
                      <li className="pt-2 pl-3">(ii) 1 张红牌 = 2 分</li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (D) 每名球员的最高积分计数为 3 分；第一张黄牌计 1 分，红牌计 2 分，第二张黄牌将不计算在内。
                  </li>
                  <li className="pt-2 pl-3">
                    (E) 如果比赛在常规比赛时间内被中止，所有总判罚数的投注将退还本金。
                  </li>
                  <li className="pt-2 pl-3">
                    (F) 上半场的总判罚数结果将在比赛官员吹哨结束上半场时确定。在比赛官员吹哨结束上半场与下半场开始之间所作的任何判罚应累积计入全场的总判罚数结果。
                  </li>
                  <li className="pt-2 pl-3">
                    (G) 全场的总判罚数结果应由直至全场结束哨声吹响时所累积的判罚数确定。全场结束哨声吹响后所作的任何判罚将不予考虑。
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XXII) 总角球数
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) 角球数结果由指定比赛中判给主队、客队或主客两队的角球总数决定（包括让分，如有）。
                  </li>
                  <li className="pt-2 pl-3">
                    (B) 重新执行的角球计为一个。
                  </li>
                  <li className="pt-2 pl-3">
                    (C) 已判罚但未执行的角球不计算在内。
                  </li>
                  <li className="pt-2 pl-3">
                    (D) 所有处于待定状态的亚洲让分盘和大/小球的总角球数投注，如果发生以下情形之一，将被取消：
                    <ol type="1">
                      <li className="pt-2 pl-3">(1) 进球；或</li>
                      <li className="pt-2 pl-3">(2) 球员被罚下场。</li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XXIII) 总换人数
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) 总换人数结果由指定比赛中主队/客队所进行的换人总数决定。
                  </li>
                  <li className="pt-2 pl-3">
                    (B) 如果比赛在常规比赛时间内被中止，所有总换人数的投注将退还本金。
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XXIV) 总越位数
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) 总越位数投注将在常规比赛时间内于指定比赛中进行结算。
                  </li>
                  <li className="pt-2 pl-3">
                    (B) 如果比赛在常规比赛时间内被中止，所有总越位数的投注将退还本金。
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XXV) 主队总进球 vs. 客队总进球
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) 主队总进球 vs. 客队总进球由所提供投注的联赛中主队所进的总进球数对客队所进的总进球数决定。
                  </li>
                  <li className="pt-2 pl-3">
                    (B) 主队指我们网站上列示的第一支球队。客队指我们网站上列示的第二支球队。
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XXVI) 球队总进球数
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) 球队总进球数由某支球队在一场比赛中所进的总进球数决定，例如：West Ham 总进球 -（大球），或 West Ham 总进球（小球）
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XXVII) 下一个动作（进球、角球或判罚）
                <div className="pt-1">
                  此投注要求您预测哪支球队将在比赛中获得下一个动作（进球、角球或判罚）。如果没有判给任何动作，所有投注将退还本金。
                </div>
              </li>
            </ol>
            <li className="flex pt-2">
              <div>5.6</div>
              <div className="pl-3">
                Type A Scoring 适用于以下为滚球投注提供的产品：
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">(A) 1X2</li>
              <li className="pt-2 pl-3">(B) 亚洲让分盘</li>
              <li className="pt-2 pl-3">(C) 单/双</li>
              <li className="pt-2 pl-3">(D) 大/小球</li>
              <li className="pt-2 pl-3">(E) 总角球数</li>
              <li className="pt-2 pl-3">(F) 总判罚数</li>
            </ol>
            <li className="flex pt-2">
              <div>5.7</div>
              <div className="pl-3">
                Type B Scoring 适用于以下为滚球投注提供的产品：
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">(A) 比赛获胜者</li>
              <li className="pt-2 pl-3">(B) 哪支球队晋级</li>
            </ol>
            <li className="flex pt-2">
              <div>5.8</div>
              <div className="pl-3">电子足球投注</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) 除本规则 20.8 另有规定外，规则 20 应适用于电子足球投注。
              </li>
              <li className="pt-2 pl-3">
                (B) 电子足球比赛是基于人工智能、机器学习和历史足球数据库的模拟，以反映球队状态和比赛过程。
              </li>
              <li className="pt-2 pl-3">
                (C) 每场比赛分为两个半场，每半场 8 分钟，总比赛时间为 16 分钟。
              </li>
              <li className="pt-2 pl-3">
                (D) 电子足球比赛结果、比分和其他决定投注的数据应为软件所产生的数据，无法从任何其他来源（包括官方球队或联赛网站）获得。
              </li>
              <li className="pt-2 pl-3">
                (E) 电子足球比赛为转播比赛，因此被视为共同投注比赛，即多于一名最终用户能够对特定比赛下注，且该比赛的结果将决定所有最终用户所下投注的结果。
              </li>
              <li className="pt-2 pl-3">
                (F) 如果任何比赛因任何类型的技术故障（包括但不限于计算机、电子、软件、硬件或连接故障）未在原定时间内完成，则该比赛应由运营商结算为未完成。在此类情形下，仅结算已被无条件确定的投注。对于所有其他市场，无论任何指示性结果如何，投注应无效，本金退还给最终用户。运营商应根据本规则结算此类比赛，运营商的决定为最终决定。
              </li>
              <li className="pt-2 pl-3">
                (G) 运营商保留在以下情况下宣布电子足球投注无效的权利：
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) 仅有部分或不正确的投注详情可用；
                  </li>
                  <li className="pt-2 pl-3">
                    (II) 运营商怀疑一名或多名最终用户参与欺诈、串通、洗钱或其他非法活动；
                  </li>
                  <li className="pt-2 pl-3">
                    (III) 比赛未开始或未完成，或结果无法确定；
                  </li>
                  <li className="pt-2 pl-3">
                    (IV) 接受该投注将超出任何投注限额；
                  </li>
                  <li className="pt-2 pl-3">
                    (V) 最终用户账户中没有该本金金额；
                  </li>
                  <li className="pt-2 pl-3">
                    (VI) 错误（人为或其他）或系统故障导致使用了不正确的赔率；
                  </li>
                  <li className="pt-2 pl-3">
                    (VII) 发生技术故障，例如通信故障、缺陷、中断、延迟、病毒、拒绝服务攻击或数据损坏；或
                  </li>
                  <li className="pt-2 pl-3">
                    (VIII) 如果技术缺陷产生了过高或异常的奖金。
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (H) 如果由于错误（人为或其他）或系统故障导致投注结算不正确，则该结算将被视为无效并予以撤销。如果最终用户账户中没有足够的资金来允许此项操作，则最终用户将被要求向运营商返还必要的金额。
              </li>
            </ol>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">6. 泰拳</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>6.1</div>
              <div className="pl-3">
                指定给拳手的红色或蓝色仅供参考。无论拳手的颜色如何变更，所有投注均视为有效。在此类情况下，将使用拳手的名字来识别赛事的获胜者。
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.2</div>
              <div className="pl-3">
                如果一名或两名参赛者（“拳手”）在比赛（“赛事”）之前或期间被裁判员或裁判取消资格，所有投注将无效。如果一名或两名拳手在赛事结束之后但在任何裁决宣布之前被裁判员或裁判取消资格，所有投注亦将无效。
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.3</div>
              <div className="pl-3">
                只有当第一回合开始的铃声响起时，赛事才被视为已开始或开赛。如果一名或两名拳手未能开始赛事，所有投注将无效。
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.4</div>
              <div className="pl-3">
                所有投注将根据赛事结束后立即在擂台上作出的官方裁决进行结算。结果的后续变更不被认可为投注目的。
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.5</div>
              <div className="pl-3">
                如果网站上使用的拳手泰文名字与非泰文名字之间存在任何不一致，应以泰文版本为准。
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.6</div>
              <div className="pl-3">
                如果运营商发现或怀疑任何赛事的结果或进行受到作弊、操纵或假赛的影响，运营商保留不经事先通知拒绝、驳回或使任何投注无效的权利。最终用户任何企图或实际作弊、操纵或操纵赛事的行为，将导致其账户被终止和/或永久禁止其持有账户，由运营商酌情决定。
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.7</div>
              <div className="pl-3">
                如果运营商发现或怀疑任何赛事的结果或进行受到作弊、操纵或假赛的影响，运营商保留不经事先通知拒绝、驳回或使任何投注无效的权利。最终用户任何企图或实际作弊、操纵或操纵赛事的行为，将导致其账户被终止和/或永久禁止其持有账户，由运营商酌情决定。
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.8</div>
              <div className="pl-3">
                如果一名或两名拳手的名字已变更但相关拳手为同一人，所有投注将有效。
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.9</div>
              <div className="pl-3">
                如果投注的价格或赔率存在错误，则必须在投注被接受后十二（12）小时内向运营商报告此类错误。投注被接受后超过十二（12）小时报告的任何错误将不予考虑。
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.10</div>
              <div className="pl-3">以下是泰拳所提供的投注：</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) 非滚球投注
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) 亚洲让分盘 — 亚洲让分盘投注与赛事的获胜者有关。如果赛事被宣布为平局，所有亚洲让分盘投注将无效。
                  </li>
                  <li className="pt-2 pl-3">
                    (II) 大/小球 — 大/小球投注与赛事中已完成的回合总数有关。赛事结束时正在进行的回合不计入回合总数。因此，如果赛事在第 5 回合结束/击倒，则已完成的回合数为四（4）。如果赛事在第五回合结束后由裁判员根据积分裁定，则已完成的回合数为五。
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (B) In Running ("Live") 投注
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) 亚洲让分盘 — 亚洲让分盘投注与赛事的获胜者有关。如果赛事被宣布为平局，所有亚洲让分盘投注将无效。
                  </li>
                </ol>
              </li>
            </ol>
            <li className="flex pt-2">
              <div>6.11</div>
              <div className="pl-3">
                适用于泰拳投注的计分系统为 Type B Scoring。
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">7. 乒乓球</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>7.1</div>
              <div className="pl-3">
                如果比赛因球员退赛或被取消资格而未完成，所有投注将无效。
              </div>
            </li>
            <li className="flex pt-2">
              <div>7.2</div>
              <div className="pl-3">
                以下是乒乓球所提供的投注：
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) 非滚球投注
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) 亚洲让分盘
                    <ol type="A">
                      <li className="pt-2 pl-3">(A) 分数让分</li>
                      <li className="pt-2 pl-3">(B) 局数让分</li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (II) 单/双
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 单/双投注与比赛中所打的分数总和（结果为单数或双数）有关。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(III) 冠军盘 (Outright)</li>
                  <li className="pt-2 pl-3">
                    (IV) 大/小球
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 大/小球投注与比赛中所打的分数总和大于或小于运营商设定的指定分数有关。
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (B) In Running ("Live") 投注
                <ol type="I">
                  <li className="pt-2 pl-3">(I) 亚洲让分盘</li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (C) 计分系统
                <div className="pt-1">适用 Type B Scoring。</div>
              </li>
            </ol>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">8. 网球</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>8.1</div>
              <div className="pl-3">
                如果比赛因球员退赛或被取消资格而未完成，所有投注将无效，但以下投注除外：第一个 Ace、第一次双误和阶段投注（如果这些投注已被无条件确定）。
              </div>
            </li>
            <li className="flex pt-2">
              <div>8.2</div>
              <div className="pl-3">
                如果锦标赛缩短赛程、延期或取消，所有投注将无效，但已被无条件确定的市场上的投注除外。
              </div>
            </li>
            <li className="flex pt-2">
              <div>8.3</div>
              <div className="pl-3">
                赢得比赛所需的总盘数由官方锦标赛主办方决定。
              </div>
            </li>
            <li className="flex pt-2">
              <div>8.4</div>
              <div className="pl-3">
                12 小时规则不适用于网球投注。
              </div>
            </li>
            <li className="flex pt-2">
              <div>8.5</div>
              <div className="pl-3">
                无论场地或场地表面如何变更，所有投注仍然有效。
              </div>
            </li>
            <li className="flex pt-2">
              <div>8.6</div>
              <div className="pl-3">以下是网球所提供的投注：</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) 非滚球投注
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) 亚洲让分盘
                    <ol type="A">
                      <li className="pt-2 pl-3">(A) 分数让分</li>
                      <li className="pt-2 pl-3">(B) 盘数让分</li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (II) 第一个 Ace
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 根据官方比赛统计数据，投注在比赛中打出第一个 Ace 的球员。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (III) 第一次双误
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 根据官方比赛统计数据，投注在比赛中第一次双误的球员。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (IV) 最多 Ace
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 根据官方比赛统计数据，投注在比赛中打出最多 Ace 的球员。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (V) 最多双误
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 根据官方比赛统计数据，投注在比赛中双误最多的球员。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (VI) 单/双
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 单/双投注根据比赛中所打的局数总和（包括比赛中出现平分时所增加的局，如适用）结算为单数或双数。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(VII) 冠军盘 (Outright)</li>
                  <li className="pt-2 pl-3">
                    (VIII) 大/小球
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 大/小球投注根据比赛结束时所打的局数总和（包括平分期间所打的局，如适用）进行结算。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (IX) 阶段投注
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 所有投注根据该盘结束时所打的局数总和（包括平分期间所打的局）进行结算。
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (B) In Running ("Live") 投注
                <ol type="I">
                  <li className="pt-2 pl-3">(I) 亚洲让分盘</li>
                  <li className="pt-2 pl-3">(II) 大/小球</li>
                  <li className="pt-2 pl-3">(III) 阶段投注</li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (C) 计分系统
                <div className="pt-1">适用 Type B Scoring。</div>
              </li>
            </ol>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">9. 排球</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>9.1</div>
              <div className="pl-3">
                如果比赛未完成，所有投注将无效，但阶段投注除外（如果投注已被无条件确定）。
              </div>
            </li>
            <li className="flex pt-2">
              <div>9.2</div>
              <div className="pl-3">
                如果通过引入额外的盘和/或黄金盘或任何其他不规则赛制（例如在友谊赛期间）而改变了比赛的法定盘数（无论是在比赛之前还是期间），则此类额外的盘或黄金盘或不规则赛制应予以忽略，所有投注应仅根据正常常规比赛过程中所取得的结果进行结算。以下是排球所提供的投注：
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) 非滚球投注
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) 亚洲让分盘
                    <ol type="A">
                      <li className="pt-2 pl-3">(A) 分数让分</li>
                      <li className="pt-2 pl-3">(B) 盘数让分</li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (II) 单/双
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 单/双投注与比赛中所打的分数总和（结果为单数或双数）有关。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(III) 冠军盘 (Outright)</li>
                  <li className="pt-2 pl-3">
                    (IV) 大/小球
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 大/小球投注与比赛中所打的分数总和大于或小于运营商设定的指定分数有关。
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (V) 阶段投注
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) 所有投注根据该阶段结束时所打的总分（包括平分期间所获得的所有分数，如适用）进行结算。
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (B) In Running ("Live") 投注
                <ol type="I">
                  <li className="pt-2 pl-3">(I) 亚洲让分盘</li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (C) 计分系统
                <div className="pt-1">适用 Type B Scoring</div>
              </li>
            </ol>
          </ol>
        </div>
      </section>
    </div>
  );
};

export default RulesContentCN;
